import { useEffect, useState } from "react";
import { Button } from "antd";
import { PencilIcon } from "../../../../../../atoms/CustomIcons";
import LastActivity from "../../LastActivity";
import LaborRateCard from "../../LabourRateCard";
import AverageRateCard from "../../AverageRateCard";
import TabsHeader from "../../TabsHeader";
import { GetLaborRatesType } from "../../../ducks/types";
import { PopUp } from "../../../../../../atoms/PopUp";
import EditHourlyRates from "../../Popups/EditHourlyRates";

interface PropsType {
  data: GetLaborRatesType;
  laborRatesId: string;
}

const HourlyRatesTab = (props: PropsType) => {
  const { data, laborRatesId } = props;
  const [regularCrewSize, setRegularCrewSize] = useState(0);
  // const [averageCrewRate, setAverageCrewRate] = useState(0);
  const [EstimatesPopUp, setEstimatesPopUp] = useState(false);

  const hourlyRatesForEstimates = {
    visibility: EstimatesPopUp,
    class: "upload_photo_modal",
    content: (
      <EditHourlyRates
        onClose={() => setEstimatesPopUp(false)}
        data={data}
        laborRatesId={laborRatesId}
        regularCrewSize={regularCrewSize}
      />
    ),
    width: 640,
    onCancel: () => setEstimatesPopUp(false),
  };

  useEffect(() => {
    if (data) {
      const totalCrewSize = data?.crewServiceLines?.reduce(
        (sum, item: { crew: { crew_size: number } }) => {
          return sum + item?.crew?.crew_size;
        },
        0
      );

      let crewSize = 0;
      // let crewRate = 0;

      if (totalCrewSize) {
        crewSize = Math.ceil(
          totalCrewSize / (data?.crewServiceLines?.length ?? 0)
        );
        // crewRate =
        //   (data?.crew_leader_rate ?? 0) +
        //   ((crewSize - 1) * (data?.technician_rate ?? 0)) /
        //     (data?.crewServiceLines?.length ?? 0);
      }

      setRegularCrewSize(crewSize ?? 0);
      // setAverageCrewRate(crewRate ?? 0);
    }
  }, [data]);

  return (
    <>
      <TabsHeader
        title="Hourly rates for estimates"
        description="The average is calculated from the crew leader and technician rates."
        tooltip="Hourly rates for estimates"
      />

      <LastActivity data={data} laborRatesId={laborRatesId} />

      <div className="cardsRow">
        <LaborRateCard
          title="Crew leader rate"
          tooltip="Crew leader rate"
          value={data?.crew_leader_rate ?? 0}
          showDollarSign={true}
        />
        <LaborRateCard
          title="Technician rate"
          tooltip="Technician rate"
          value={data?.technician_rate ?? 0}
          showDollarSign={true}
        />
        <LaborRateCard
          title="Regular crew size"
          tooltip="Regular crew size"
          value={regularCrewSize ?? 0}
        />
      </div>

      <AverageRateCard
        title="Average rate for estimates"
        rate={data?.labor_rate ?? 0}
      />

      <Button
        htmlType="submit"
        type="primary"
        className="editRate"
        onClick={(e) => {
          e.stopPropagation();
          setEstimatesPopUp(true);
        }}
      >
        <PencilIcon /> Edit rates
      </Button>

      <PopUp {...hourlyRatesForEstimates} />
    </>
  );
};

export default HourlyRatesTab;
